import React from "react";

import LottieAnimationWrapper from "../Lottie/LottieAnimationWrapper";

// import globeAnimation from "assets/lottie/globe.json";
import animation from "assets/lottie/tms.json";

const TableLoader = () => {
  return <LottieAnimationWrapper lottieFile={animation} height={300} />;
};

export default TableLoader;
